import React from 'react';

export default function Divider(): JSX.Element {
  return <div className="divider" />;
}
